import type React from 'react';
import {Modal, Button, Tooltip} from 'antd';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimes} from '@fortawesome/pro-solid-svg-icons';
import {faExclamationTriangle} from '@fortawesome/pro-duotone-svg-icons';
import styles from './styles.module.scss';
import FreezeWrapper from '@/components/dashboard/pages/otto-page-detail/Component/freezTooltip';
import {StyledTrashIcon} from '@/components/dashboard/pages/otto-page-detail/style';
import {faTrash} from '@fortawesome/pro-regular-svg-icons';
import {observer} from 'mobx-react';
import {useState, useEffect} from 'react';
import {useStore} from '@/store/root-store';
interface ConfirmationModalProps {
  record: any;
  uuid: string;
  style?: React.CSSProperties;
}

const ConfirmationModalV2: React.FC<ConfirmationModalProps> = observer(({
  record,
  uuid,
  style,
}) => {
  const {ottoV2Store: {ignoreFixes, setIssueTypeSelected, loadOttoV2Project, setIsDeploying}} = useStore('');
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(record);

  useEffect(() => {
    setCurrentRecord(record);
  }, [record]);

  // const [dontShowAgain, setDontShowAgain] = useState(JSON.parse(localStorage.getItem('dontShowAgain') || 'false'));
  // const onCheckboxChange = (checked: boolean) => {
  //   localStorage.setItem('dontShowAgain', JSON.stringify(checked));
  //   setDontShowAgain(checked);
  // };


  const onDeleteRecord = async () => {
    // if (dontShowAgain) {
    //   await deleteRecord(record);
    // } else {
    setVisible(true);
    // }
  };

  const deleteRecord = async () => {
    setLoading(true);
    try {
      const payload = {'otto_urls_ids': [currentRecord?.id], 'issue_type': currentRecord?.issueType, 'to_ignore': true};
      await ignoreFixes(uuid, payload, true);
      setIssueTypeSelected(currentRecord?.issueType);
      setIsDeploying(true);
      setIssueTypeSelected(currentRecord?.issueType);
      loadOttoV2Project(uuid, true);
    } finally {
      setLoading(false);
      setVisible(false);
    }
  };
  return (
    <div style={style} className='hover-visible'>
      <FreezeWrapper placement='topRight' removeTooltip={currentRecord?.isApproved}>
        <Tooltip title='Remove Suggestion' placement='bottom' overlayClassName={styles.tooltipStyle}>
          <StyledTrashIcon icon={faTrash} onClick={()=> onDeleteRecord()} fontSize={14} color='#A3A4A4'/>
        </Tooltip>
      </FreezeWrapper>
      {visible && <Modal
        open={visible}
        footer={null}
        closable={true}
        closeIcon={<FontAwesomeIcon icon={faTimes} className={styles.closeIcon} />}
        onCancel={()=> setVisible(false)}
        className={styles.confirmationModal}
        width={650}
        maskClosable={false}
      >
        <div>
          <div className={styles.iconContainer}>
            <FontAwesomeIcon icon={faExclamationTriangle} color='#f04747' className={styles.warningIcon} />
          </div>
          <div className={styles.modalBody}>
            <h2 className={styles.modalTitle}>Remove this OTTO suggestion</h2>
            {/* <div className={styles.checkboxContainer}>
            <Checkbox onChange={e => onCheckboxChange?.(e.target.checked)}>
              <span className={styles.checkboxText}>Don&apos;t show a confirmation modal anymore</span>
            </Checkbox>
          </div> */}
            <div className={styles.buttonContainer}>
              <Button className={styles.confirmButton} onClick={deleteRecord} disabled={loading} loading={loading}>
               Yes, remove it!
              </Button>
              <button className={styles.cancelButton} onClick={()=> setVisible(false)}>
              Cancel
              </button>
            </div>
          </div>
        </div>
      </Modal>}
    </div>
  );
});

export default ConfirmationModalV2;
